import { LoginDIRResponse } from '../../../../../types/api/endpoints/auth/login.types';
import { AUTH_ENDPOINTS } from '../../../../../utils/api/endpoints/authEndpoints';
import { LoginDIRFormSchema } from './LoginDIRForm.types';

const PREFIX = '[loginDIRQuery]';

export const LOGIN_DIR_QUERY_KEY = 'LOGIN_DIR';

export const loginDIRQuery = async ({ email, password }: LoginDIRFormSchema) => {
  console.log(PREFIX, `Requesting DIR login...`);
  const response = await AUTH_ENDPOINTS.loginDIR({ email, password });

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received DIR login response.`);
  return json as LoginDIRResponse;
};
